module.exports = __webpack_public_path__ + "static/img/24.b2f6fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/24.png
// module id = qClN
// module chunks = 0